import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { openReplayService } from '../services/openreplay.service';

/**
 * Revisão do #665: o tracker começa no App e nada o parava. Quem ia do
 * `/pix/<pedido>` para o `/compra-aprovada` (tracker liga) e voltava tinha a
 * página do PIX gravada (DOM com o QR, console, rede).
 *
 * Fica ANTES do `<Routes>` e usa `useLayoutEffect`: roda no mesmo commit que
 * monta a página nova, antes dos `useEffect` dela (console, fetch) e antes do
 * MutationObserver do tracker ver o DOM novo.
 */
export default function OpenReplayNaRota() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    openReplayService.aoTrocarDeRota(pathname);
  }, [pathname]);
  return null;
}
